import { Controller } from "@hotwired/stimulus";

// controller to resize input fields in the feed, for example comment input and post input

export default class extends Controller {
  connect() {
    // Listen for any change events on the form.
    this.element.addEventListener("change", this.submit.bind(this));
    this.updateActiveButton();
  }

  submit() {
    // Automatically submit the form. Using requestSubmit ensures form validations are run.
    this.element.requestSubmit();
    this.updateActiveButton();
  }

  updateActiveButton() {
    // Remove active class from all buttons
    this.element.querySelectorAll(".button--category").forEach((button) => {
      button.classList.remove("button--category--active");
    });

    // Add active class to the selected button
    const selectedRadio = this.element.querySelector(".category-radio:checked");
    if (selectedRadio) {
      selectedRadio
        .closest(".button--category")
        .classList.add("button--category--active");
    }
  }
}
